import styled, { css } from 'styled-components';
import marginProps from 'styled/shared-props/margin';
import colors from 'theme/colors';
import fonts from 'theme/fonts';
import sizes from 'theme/sizes';

export const StyledPaginate = styled.nav`
    ${marginProps}
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: ${sizes.immense};
    user-select: none;
`;

export const StyledContentPaginate = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${sizes.nano};

    @media (max-width: 480px) {
        gap: ${sizes.quark};
    }
`;

const baseButtonStyles = css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    font-family: inherit;
    transition: all 0.2s ease;
    -webkit-tap-highlight-color: transparent;

    &:focus-visible {
        outline: 2px solid ${colors.primaryLight};
        outline-offset: 2px;
    }

    &:disabled {
        cursor: default;
        opacity: 0.35;
    }
`;

export const StyledButtonAction = styled.button`
    ${baseButtonStyles}
    width: 40px;
    height: 40px;
    border-radius: ${sizes.mini};
    background: ${colors.neutralLight};
    color: ${colors.primary};
    border: 1px solid ${colors.neutralDark};
    flex-shrink: 0;

    &:not(:disabled):hover {
        background: ${colors.primary};
        border-color: ${colors.primary};
        color: ${colors.neutralLight};

        svg path {
            stroke: ${colors.neutralLight};
        }
    }

    &:not(:disabled):active {
        transform: scale(0.93);
    }

    svg {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    svg path {
        stroke: ${colors.primary};
        transition: stroke 0.2s ease;
    }

    &:disabled svg path {
        stroke: ${colors.nightLight};
    }

    @media (max-width: 480px) {
        width: 36px;
        height: 36px;

        svg {
            width: 14px;
            height: 14px;
        }
    }
`;

export const StyledButtonPage = styled.button`
    ${baseButtonStyles}
    min-width: 40px;
    height: 40px;
    padding: 0 ${sizes.nano};
    border-radius: ${sizes.mini};
    background: transparent;
    color: ${colors.night};
    font-size: ${fonts.sizes.default};
    font-weight: ${fonts.weight.regular};
    border: 1px solid transparent;

    &:not(:disabled):hover {
        background: ${colors.neutralBackground};
        color: ${colors.primary};
    }

    &:not(:disabled):active {
        transform: scale(0.93);
    }

    ${({ active }) => active && css`
        background: ${colors.primary};
        color: ${colors.neutralLight};
        font-weight: ${fonts.weight.bold};
        pointer-events: none;
        border-color: ${colors.primary};
    `}

    @media (max-width: 480px) {
        min-width: 36px;
        height: 36px;
        font-size: ${fonts.sizes.small};
    }
`;

export const StyledEllipsis = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 40px;
    color: ${colors.nightLight};
    font-size: ${fonts.sizes.default};
    letter-spacing: 2px;

    @media (max-width: 480px) {
        min-width: 24px;
        height: 36px;
        font-size: ${fonts.sizes.small};
    }
`;

export const StyledMobileIndicator = styled.span`
    display: none;
    align-items: center;
    justify-content: center;
    font-size: ${fonts.sizes.default};
    color: ${colors.night};
    white-space: nowrap;
    padding: 0 ${sizes.mini};

    strong {
        font-weight: ${fonts.weight.bold};
        color: ${colors.primary};
        margin: 0 3px;
    }

    @media (max-width: 380px) {
        display: inline-flex;
    }
`;

export const StyledPageNumbers = styled.div`
    display: flex;
    align-items: center;
    gap: ${sizes.nano};

    @media (max-width: 380px) {
        display: none;
    }

    @media (max-width: 480px) {
        gap: ${sizes.quark};
    }
`;
